/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

// Our lucide build predates its fax icon, so this is a local glyph in the same
// grammar: 24-unit grid, stroke width 2, round caps and joins.

export function FaxIcon({
  size = 24,
  strokeWidth = 2,
  className,
}: {
  size?: number | undefined;
  strokeWidth?: number | undefined;
  className?: string | undefined;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <path d="M8 9V4a1 1 0 0 1 1-1h6l3 3v3" />
      <rect x="6" y="9" width="14" height="11" rx="2" />
      <rect x="2" y="7" width="4" height="13" rx="1.5" />
      <path d="M11 13h.01M15 13h.01M11 16.5h.01M15 16.5h.01" />
    </svg>
  );
}
